module.exports = __webpack_public_path__ + "static/media/1.ac07e50f.svg";